import "./App.css";
import Nav from "./components/Nav";
import { Footer } from "./components/Footer";
import { Home } from "./sections/Home";
import { Services } from "./sections/Services";
import { Contact } from "./sections/Contact";

function App() {
  return (
    <>
      <Nav />
      <main>
        <Home />
        <Services />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
